import { render } from "./Notifiche.vue?vue&type=template&id=034b0785&scoped=true"
import script from "./Notifiche.vue?vue&type=script&lang=js"
export * from "./Notifiche.vue?vue&type=script&lang=js"

import "./Notifiche.vue?vue&type=style&index=0&id=034b0785&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034b0785"]])

export default __exports__